import { Box, Typography } from '@mui/material'
import {
  useHouseholdApplianceTypes,
  useResidentialHouseholdApplianceProducers,
  useFlatHouseholdAppliances,
  useWarehouseHouseholdAppliances
} from '@services/protocols/hooks/protocolHouseholdAppliances'
import { useMemo } from 'react'
import { format } from 'date-fns'
import { pl } from 'date-fns/locale'

function HouseholdApplianceTypePreview({ id, protocolId }: { id: number; protocolId: number }) {
  const { getHouseholdApplianceNameById } = useHouseholdApplianceTypes()
  const { getHouseholdApplianceProducerNameById } = useResidentialHouseholdApplianceProducers()
  const { flatHouseholdAppliances } = useFlatHouseholdAppliances(protocolId)
  const { warehouseHouseholdAppliances } = useWarehouseHouseholdAppliances(protocolId)

  const householdAppliance = useMemo(() => {
    return [...flatHouseholdAppliances, ...warehouseHouseholdAppliances].find(
      (appliance) => appliance.id === id
    )
  }, [flatHouseholdAppliances, warehouseHouseholdAppliances, id])

  if (householdAppliance == null) {
    return <Typography variant='body2'>Nie znaleziono urządzenia.</Typography>
  }

  return (
    <Box>
      <Typography
        variant='h6'
        sx={{
          fontWeight: 'bold'
        }}
      >
        {getHouseholdApplianceNameById(householdAppliance?.type)}
      </Typography>
      <Typography variant='body2'>
        Producent: {getHouseholdApplianceProducerNameById(householdAppliance?.producer)}
      </Typography>
      <Typography variant='body2'>Numer seryjny: {householdAppliance?.serialNumber}</Typography>
      <Typography variant='body2'>Status: {householdAppliance?.status}</Typography>
      <Typography variant='body2'>
        Data zakupu:{' '}
        {!!householdAppliance.purchaseDate
          ? format(new Date(householdAppliance.purchaseDate as string), 'dd.MM.yyyy', {
              locale: pl
            })
          : 'Brak danych'}
      </Typography>
    </Box>
  )
}

export default HouseholdApplianceTypePreview
